import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select"; 
import moment from "moment";

const PaymentDetails = () => {
  const [formData, setFormData] = useState({
    name: "",
    personId: "",
    paymentCategory: [""],
    date: [""],
    fromDate: "",
    toDate: "",
    totalAmount: "",
    paidAmount: [""],
    remainingAmount: "",
    notes: "",
    transitionId: [""],
    category: "",
    alertDate: "", 
    alertDays: "",
    actualId: "",
    paymentId: "",
  });

  const [formData1, setFormData1] = useState({});

  const [names, setNames] = useState([]);
  const [paymentList, setPaymentList] = useState([]);
  const [editId, setEditId] = useState(null);
  const [expandedRows, setExpandedRows] = useState([]);
  const [expandedRows1, setExpandedRows1] = useState([]);

  const [actualIds, setActualIds] = useState([]);

  const fetchActualIds = async (personId) => {
    try {
      const response = await axios.get(`https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/getActualIds/${personId}`);
      const actualIdsArray = response.data.actualIds
      .filter(({ totalAmount }) => totalAmount > 0)
      .map(({ actualId, totalAmount, fromDate, toDate, alertDate, alertDays }) => ({
        label: `${actualId} (Total: ₹${totalAmount})`,
        value: actualId,
        totalAmount,
        fromDate,
        toDate,
        alertDate,
        alertDays,
      }));
      setActualIds(actualIdsArray);
    } catch (error) {
      console.error("Error fetching actualIds:", error);
    }
  };

  useEffect(() => {
    fetchNames();
    fetchPayments();
    fetchPersons();
  }, []);

  const fetchNames = async () => {
    const response = await axios.get("https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/getNames1");
    const namesArray = Object.values(response.data).map(person => ({
        id: person.personId,
        label: `${person.personId}-${person.name}`,
        value: person.name 
    }));
    setNames(namesArray);
  };

  const [persons, setPersons] = useState([]);
  const [filteredPerson, setFilteredPerson] = useState(null);

  const fetchPersons = async () => {
    try {
      const response = await axios.get("https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/getPersons");
      setPersons(
        Object.entries(response.data).map(([key, value]) => ({
          id: key,
          fromDate: value.fromDate || [],
          toDate: value.toDate || [],
          paymentDate: value.paymentDate || [],
          alertDate: value.alertDate || [],
          alertDays: value.alertDays || [],
          totalAmount: value.totalAmount || [],
          ...value,
        }))
      );
    } catch (error) {
      console.error("Error fetching persons:", error);
    }
  };
  
  


  const fetchPayments = async () => {
    const response = await axios.get("https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/getPayments");
    setPaymentList(response.data);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    const updatedFormData = { ...formData, [name]: value };
  
    // Recalculate remaining amount whenever totalAmount or paidAmount changes
    const total = parseFloat(updatedFormData.totalAmount) || 0;
    const paidAmounts = updatedFormData.paidAmount.map((amt) => parseFloat(amt) || 0);
    const totalPaid = paidAmounts.reduce((sum, amt) => sum + amt, 0);
    const remaining = Math.max(total - totalPaid, 0);
    console.log("remaining:", remaining);

    setFormData({ ...updatedFormData, totalPaid, remainingAmount: remaining });
  };
  


  const handleSelectChange = (selectedOption) => {
    setFormData((prev) => ({ ...prev, name: selectedOption.value, personId: selectedOption.id }));

    const selectedPerson = persons.find(person => person.personId === selectedOption.id);
    setFilteredPerson(selectedPerson || null);
    fetchActualIds(selectedOption.id);
  };

  // const handleSelectChange = (selectedOption) => {
  //   setFormData(prev => ({ ...prev, name: selectedOption.value, personId: selectedOption.id }));

  //   const selectedPerson = names.find(person => person.id === selectedOption.id);
  //   setFilteredPerson(selectedPerson || null);

  //   fetchActualIds(selectedOption.id);
  // };


  const handleActualIdChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      actualId: selectedOption.value,
      totalAmount: selectedOption.totalAmount,
      fromDate: selectedOption.fromDate,
      toDate: selectedOption.toDate,
      alertDate: selectedOption.alertDate,
      alertDays: selectedOption.alertDays,
      paidAmount: [""], // Reset paid amounts
      remainingAmount: selectedOption.totalAmount,
    }));
  };

  const handleAddSubfield = (field) => {
    setFormData((prev) => ({
      ...prev,
      [field]: [...prev[field], ""]
    }));
  };

  const handlePaidAmountChange = (e) => {
    const enteredAmount = parseFloat(e.target.value);
    const totalAmount = parseFloat(formData.totalAmount);
  
    if (enteredAmount > totalAmount) {
      alert(`Paid amount cannot exceed the total amount of ₹${totalAmount}`);
      return;
    }
  
    setFormData((prev) => ({
      ...prev,
      paidAmount: [enteredAmount, ...prev.paidAmount.slice(1)],
    }));
  };
  

  const handleRemoveSubfield = (field, index) => {
    const updatedField = formData[field].filter((_, i) => i !== index);

    // Update remaining amount if paidAmount field is changed
    if (field === "paidAmount") {
      const total = parseFloat(formData.totalAmount) || 0;
      const paidAmounts = updatedField.map((amt) => parseFloat(amt) || 0);
      const remaining = Math.max(total - paidAmounts.reduce((sum, amt) => sum + amt, 0), 0);
      setFormData((prev) => ({
        ...prev,
        remainingAmount: remaining,
        [field]: updatedField
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [field]: updatedField
      }));
    }
  };

  const handleSubfieldChange = (e, field, index) => {
    const value = e.target.value;
  
    const updatedField = Array.isArray(formData[field]) ? [...formData[field]] : [];
    updatedField[index] = value;
  
    if (field === "paidAmount") {
      const totalAmount = parseFloat(formData.totalAmount) || 0;
      const paidAmounts = updatedField.map((amt) => parseFloat(amt) || 0);
      const totalPaid = paidAmounts.reduce((sum, amt) => sum + amt, 0);
  
      if (totalPaid > totalAmount) {
        alert(`Paid amount cannot exceed total amount of ₹${totalAmount}`);
        return;
      }
  
      const remaining = Math.max(totalAmount - totalPaid, 0);
  
      setFormData((prev) => ({
        ...prev,
        totalPaid,
        remainingAmount: remaining,
        [field]: updatedField,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [field]: updatedField,
      }));
    }
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    const updatedFormData = {
      ...formData,
      paymentId: Array.isArray(formData.paymentId)
        ? [...formData.paymentId]
        : [formData.paymentId],
    };
    
    try {
      if (editId) {
        await axios.put(`https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/updatePayment/${editId}`, updatedFormData);
        alert("Payment updated successfully");
      } else {
        await axios.post("https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/addPayment", updatedFormData);
        alert("Payment added successfully");
      }
      resetForm();
      fetchPayments();
    } catch (error) {
      console.error("Error submitting payment:", error);
      alert("Failed to submit payment");
    }
  };

  const resetForm = () => {
    setFormData({
      name: "",
      personId: "",
      paymentCategory: [""],
      date: [""],
      fromDate: "",
      toDate: "",
      totalAmount: "",
      paidAmount: [""],
      remainingAmount: "",
      notes: "",
      transitionId: [""],
      category: "",
      alertDate: "",
      alertDays: "",
      actualId: "",
      paymentId: "",
    });
    setEditId(null);
  };

  const handleEdit = (id) => {
    const entry = paymentList.find((item) => item.id === id);
    setFormData(entry);
    setEditId(id);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/deletePayment/${id}`);
      alert("Payment deleted successfully");
      fetchPayments();
    } catch (error) {
      console.error("Error deleting payment:", error);
      alert("Failed to delete payment");
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  };

  const toggleRow = (id) => {
    setExpandedRows1((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const getAlertColor = (alertDate, alertDays) => {
    const startDate = moment(alertDate).subtract(alertDays, "days");
    const endDate = moment(alertDate);
    const currentDate = moment();

    return currentDate.isBetween(startDate, endDate, "days", "[]")
      ? "bg-danger text-dark"
      : "";
  };
  
  const handleExpandRow = (id) => {
    setExpandedRows((prevRows) =>
      prevRows.includes(id) ? prevRows.filter((rowId) => rowId !== id) : [...prevRows, id]
    );
  };

  const [editRowIndex, setEditRowIndex] = useState(null);

  const handleEditRow = (person, index) => {
    if (index < 0 || index >= (person.fromDate?.length || 0)) {
      console.error("Invalid index:", index);
      return;
    }
  
    setEditRowIndex(index);
    setFormData1({
      fromDate: person.fromDate?.[index] || "",
      toDate: person.toDate?.[index] || "",
      paymentDate: person.paymentDate?.[index] || "",
      alertDate: person.alertDate?.[index] || "",
      alertDays: person.alertDays?.[index] || "",
      totalAmount: person.totalAmount?.[index] || "",
    });
  };
  
  

  const handleSaveRow = async (personId, index) => {
    const updatedData = ["fromDate", "toDate", "paymentDate", "alertDate", "alertDays", "totalAmount"].reduce(
      (acc, key) => {
        acc[key] = [...(persons.find((p) => p.id === personId)?.[key] || [])];
        acc[key][index] = formData1[key]; // Use formData1 for updates
        return acc;
      },
      {}
    );
  
    try {
      // Call the backend to update the database
      const response = await axios.put(
        `https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/updatePersonPayment/${personId}`,
        updatedData
      );
  
      if (response.status === 200) {
        // Update local state after successful backend update
        const updatedPersons = persons.map((person) =>
          person.id === personId ? { ...person, ...updatedData } : person
        );
        setPersons(updatedPersons);
        setEditRowIndex(null);
        alert("Row updated successfully!");
      } else {
        alert("Failed to update row. Please try again.");
      }
    } catch (error) {
      console.error("Error updating person:", error);
      alert("An error occurred while updating the row.");
    }
  };
  

const handleCancelEdit = () => {
  setEditRowIndex(null);
};

const calculateMaxLength = (person) =>
  Math.max(
    person.fromDate?.length || 0,
    person.toDate?.length || 0,
    person.paymentDate?.length || 0,
    person.alertDate?.length || 0,
    person.alertDays?.length || 0,
    person.totalAmount?.length || 0
  );

  const handleGenerateActualId = async () => {
    const selectedName = names.find(option => option.value === formData.name);
    if (selectedName) {
      try {
        const response = await axios.post("https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/generateActualId", {
          personId: selectedName.id,
        });
  
        setFormData(prev => ({ ...prev, actualId: response.data.actualId }));
      } catch (error) {
        alert("Error generating Actual ID: " + error.message);
      }
    } else {
      alert("Please select a name to generate the Actual ID.");
    }
  };
  

  const handleGeneratePaymentId = async () => {
    const selectedName = names.find((option) => option.value === formData.name);
    if (selectedName) {
      try {
        const response = await axios.post(
          "https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/generatePaymentId",
          { personId: selectedName.id }
        );
  
        const newPaymentId = response.data.paymentId;
        setFormData((prev) => ({
          ...prev,
          paymentId: Array.isArray(prev.paymentId) ? [...prev.paymentId, newPaymentId] : [newPaymentId],
        }));
      } catch (error) {
        console.error("Error generating Payment ID:", error.message);
        alert("Error generating Payment ID. Please try again.");
      }
    } else {
      alert("Please select a name to generate the Payment ID.");
    }
  };
  

const [newRowData, setNewRowData] = useState(null);

const handleAddRow = (personId) => {
  setNewRowData({
    personId,
    fromDate: "",
    toDate: "",
    paymentDate: "",
    alertDate: "",
    alertDays: "",
    totalAmount: "",
  });
};

const handleSaveNewRow = async (personId) => {
  try {
    // Send newRowData to the backend
    const response = await axios.put(
      `https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/addPersonPayment/${personId}`,
      newRowData
    );

    if (response.status === 200) {
      // Update local state after successful backend update
      const updatedPersons = persons.map((person) => {
        if (person.id === personId) {
          return {
            ...person,
            fromDate: [...(person.fromDate || []), newRowData.fromDate],
            toDate: [...(person.toDate || []), newRowData.toDate],
            paymentDate: [...(person.paymentDate || []), newRowData.paymentDate],
            alertDate: [...(person.alertDate || []), newRowData.alertDate],
            alertDays: [...(person.alertDays || []), newRowData.alertDays],
            totalAmount: [...(person.totalAmount || []), newRowData.totalAmount],
          };
        }
        return person;
      });

      setPersons(updatedPersons);
      setNewRowData(null);
      alert("New row added successfully!");
    } else {
      alert("Failed to add new row. Please try again.");
    }
  } catch (error) {
    console.error("Error adding new row:", error);
    alert("An error occurred while adding the row.");
  }
};

const handleCancelNewRow = () => {
  setNewRowData(null);
};

const [isEditingPaymentId, setIsEditingPaymentId] = useState(false);

const handleEditPaymentId = () => {
  setIsEditingPaymentId((prev) => !prev);
};

useEffect(() => {
  if (formData.personId) {
    fetchActualIds(formData.personId);
  }
}, [formData.personId]);


  return (
    <div className="container1">
      <h3 className="text-center">Payment Details</h3>
      <div className="container1">
      <table className="table table-striped mt-4">
        <thead>
          <tr>
            <th>S.NO</th>
            <th>PersonId</th>
            <th>Player Image</th>
            <th>Name</th>
            <th>DOB</th>
            <th>Age</th>
            <th>Gender</th>
            <th>Blood Group</th>
            <th>Address</th>
            <th>Player Occupation</th>
            <th>Parents Occupation</th>
            <th>Experience</th>
            <th>Weight</th>
            <th>Height</th>
            <th>Game</th>
            <th>Payment Info</th>
            <th>Add</th>
          </tr>
        </thead>
        <tbody>
          {(filteredPerson ? [filteredPerson] : persons).map((person, index) => (
            <React.Fragment key={person.id}>
              <tr>
                <td>{index + 1}</td>
                <td>{person.personId || 'null'}</td>
                <td>{person.playerImage}</td>
                <td>{person.name}</td>
                <td>{person.dob}</td>
                <td>{person.age}</td>
                <td>{person.gender || 'N/A'}</td>
                <td>{person.bloodGroup}</td>
                <td>{person.address}</td>
                <td>{person.playerOccupation}</td>
                <td>{person.parentsOccupation}</td>
                <td>{person.yearsOfExperience}</td>
                <td>{person.weight}</td>
                <td>{person.height}</td>
                <td>{person.game}</td>
                <td>
                  <button
                    onClick={() => handleExpandRow(person.id)}
                    className={`btn btn-info btn-sm mt-2 ${expandedRows.includes(person.id) ? 'btn-danger' : ''}`}
                  >
                    {expandedRows.includes(person.id) ? '▲' : '▼'}
                  </button>
                </td>
                <td>
                  <button
                    className="btn btn-success btn-sm"
                    onClick={() => handleAddRow(person.id)}
                  >
                    Add
                  </button>
                </td>
              </tr>
              {expandedRows.includes(person.id) && (
                <tr>
                  <td colSpan="18">
                    <table className="table mt-3 subtable">
                      <thead>
                        <tr>
                          <th>Actual Id</th>
                          <th>From Date</th>
                          <th>To Date</th>
                          <th>Payment Date</th>
                          <th>Alert Date</th>
                          <th>Alert Days</th>
                          <th>Total Amount</th>
                          
                          <th>Edit</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.from({ length: calculateMaxLength(person) }).map((_, index) => (
                          <tr key={index}>
                          <td>{person.actualId?.[index] || ''}</td>
                            {/* Editable fields */}
                            {["fromDate", "toDate", "paymentDate", "alertDate", "alertDays", "totalAmount"].map((field) => (
                              <td key={field}>
                                {editRowIndex === index ? (
                                  <input
                                    type={field.includes("Date") ? "date" : "number"}
                                    value={formData1[field] || ""} // Use formData1 for editable fields
                                    onChange={(e) =>
                                      setFormData1({ ...formData1, [field]: e.target.value }) // Update formData1 state
                                    }
                                  />
                                ) : (
                                  person[field]?.[index] || "" // Display the value at the index
                                )}
                              </td>
                            ))}

                            {/* Edit Column */}
                            <td>
                              {editRowIndex === index ? (
                                <button
                                  className="btn btn-success btn-sm"
                                  onClick={() => handleSaveRow(person.id, index)}
                                >
                                  Save
                                </button>
                              ) : (
                                <button
                                  className="btn btn-warning btn-sm"
                                  onClick={() => handleEditRow(person, index)}
                                >
                                  Edit
                                </button>
                              )}
                            </td>

                            {/* Actions Column */}
                            <td>
                              {editRowIndex === index ? (
                                <button className="btn btn-secondary btn-sm" onClick={handleCancelEdit}>
                                  Cancel
                                </button>
                              ) : (
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => handleDelete(person.id)}
                                >
                                  Delete
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                        {newRowData?.personId === person.id && (
                              <tr>
                                {["fromDate", "toDate", "paymentDate", "alertDate", "alertDays", "totalAmount"].map((field) => (
                                  <td key={field}>
                                    <input
                                      type={field.includes("Date") ? "date" : "number"}
                                      value={newRowData[field] || ""}
                                      onChange={(e) =>
                                        setNewRowData({ ...newRowData, [field]: e.target.value })
                                      }
                                    />
                                  </td>
                                ))}
                                <td>
                                  <button
                                    className="btn btn-success btn-sm"
                                    onClick={() => handleSaveNewRow(person.id)}
                                  >
                                    Save
                                  </button>
                                  <button
                                    className="btn btn-secondary btn-sm"
                                    onClick={handleCancelNewRow}
                                  >
                                    Cancel
                                  </button>
                                </td>
                              </tr>
                            )}
                      </tbody>


                    </table>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
      <form className="container" onSubmit={handleSubmit}>
      <div className="row mb-3">
        <div className="col-md-4">
          <label>Name:</label>
          <Select
            options={names}
            value={names.find((option) => option.value === formData.name)}
            onChange={handleSelectChange}
            placeholder="Select or search a name"
          />
        </div>
        <div className="col-md-4">
        <label>Actual ID:</label>
        <div className="d-flex align-items-center">
          <Select
            options={actualIds}
            value={actualIds.find(option => option.value === formData.actualId) || null}
            onChange={handleActualIdChange}
            placeholder="Select or search an Actual ID"
          />
        </div>
      </div>
        <div className="col-md-4">
          <label>Payment ID:</label>
          <div className="d-flex align-items-center">
            <input
              type="text"
              className="form-control"
              name="paymentId"
              value={formData.paymentId || ""}
              readOnly
            />
            <button
              type="button"
              className="btn btn-secondary ml-2"
              onClick={handleGeneratePaymentId}
            >
              Payment Id
            </button>
          </div>
        </div>
        </div>
       
        <div className="col-md-4">
          <label>Payment Category:</label>
          {/* Default Payment Category Field */}
          <select
            className="form-control mb-2"
            name="paymentCategory"
            value={formData.paymentCategory[0] || ""}
            onChange={(e) => handleSubfieldChange(e, "paymentCategory", 0)}
          >
            <option value="">Select Payment</option>
            <option value="Cash">Cash</option>
            <option value="UPI">UPI</option>
            <option value="Net Banking">Net Banking</option>
          </select>
          <button
            type="button"
            className="btn mt-2 col-md-8"
            onClick={() => handleAddSubfield("paymentCategory")}
            style={{width: "300px"}}
          >
            + Add Payment
          </button>
         
          {/* Dynamically Added Subfields */}
          {formData.paymentCategory.slice(1).map((category, index) => (
            <div key={index} className="d-flex align-items-center mb-2">
              <select
                className="form-control"
                value={category || ""}
                onChange={(e) =>
                  handleSubfieldChange(e, "paymentCategory", index + 1)
                }
                style={{width: "300px"}}
              >
                <option value="">Select Category</option>
                <option value="Cash">Cash</option>
                <option value="UPI">UPI</option>
                <option value="Net Banking">Net Banking</option>
              </select>
              <button
                type="button"
                className="btn btn-danger ml-2"
                onClick={() => handleRemoveSubfield("paymentCategory", index + 1)}
                style={{width:"50px"}}
              >
                -
              </button>
            </div>
          ))}

          {/* Add New Subfield Button */}
         
        </div>


        <div className="col-md-4">
          <label>Category:</label>
          <select
            className="form-control"
            name="category"
            value={formData.category}
            onChange={handleChange}
          >
            <option value="">Select Category</option>
            <option value="SingleDetails">Single person</option>
            <option value="Membership">Membership</option>
          </select>
        </div>

        <div className="col-md-4">
          <label>Payment Date:</label>
          {/* Default Payment Date Field */}
          <input
            type="date"
            className="form-control mb-2"
            name="date"
            value={formData.date[0]}
            onChange={(e) => handleSubfieldChange(e, "date", 0)}
          />

        

          {/* Dynamically Added Subfields for Payment Date */}
          {formData.date.slice(1).map((date, index) => (
            <div key={index} className="d-flex align-items-center mb-2">
              <input
                type="date"
                className="form-control"
                value={date}
                onChange={(e) => handleSubfieldChange(e, "date", index + 1)}
                style={{ width: "300px" }}
              />
              <button
                type="button"
                className="btn btn-danger ml-2"
                onClick={() => handleRemoveSubfield("date", index + 1)}
                style={{ width: "50px" }}
              >
                -
              </button>
            </div>
          ))}

          {/* Add New Subfield Button for Payment Date */}
          <button
            type="button"
            className="btn mt-2 col-md-8"
            onClick={() => handleAddSubfield("date")}
            style={{ width: "300px" }}
          >
            + Add Date
          </button>
        </div>
        <div className="col-md-4">
        <label>Paid Amount:</label>
        <input
          type="number"
          className="form-control mb-2"
          name="paidAmount"
          value={formData.paidAmount[0]}
          onChange={(e) => handleSubfieldChange(e, "paidAmount", 0)}
        />

        {formData.paidAmount.slice(1).map((amount, index) => (
          <div key={index} className="d-flex align-items-center mb-2">
            <input
              type="number"
              className="form-control"
              value={amount}
              onChange={(e) => handleSubfieldChange(e, "paidAmount", index + 1)}
              style={{ width: "300px" }}
            />
            <button
              type="button"
              className="btn btn-danger ml-2"
              onClick={() => handleRemoveSubfield("paidAmount", index + 1)}
              style={{ width: "50px" }}
            >
              -
            </button>
          </div>
        ))}

        <button
          type="button"
          className="btn mt-2 col-md-8"
          onClick={() => handleAddSubfield("paidAmount")}
          style={{ width: "300px" }}
        >
          + Add Paid Amount
        </button>
      </div>



        <div className="col-md-4">
          <label>Remaining Amount:</label>
          <input
            type="number"
            className="form-control"
            name="remainingAmount"
            value={formData.remainingAmount}
            readOnly
          />
        </div>

        <div className="col-md-8">
          <label>Notes:</label>
          <textarea
            className="form-control"
            name="notes"
            value={formData.notes}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-4">
          <label>Transition Id:</label>
          <input
            type="text"
            className="form-control mb-2"
            name="transitionId"
            value={formData.transitionId[0]}
            onChange={(e) => handleSubfieldChange(e, "transitionId", 0)}
          />

          {formData.transitionId.slice(1).map((id, index) => (
            <div key={index} className="d-flex align-items-center mb-2">
              <input
                type="text"
                className="form-control"
                value={id}
                onChange={(e) => handleSubfieldChange(e, "transitionId", index + 1)}
                style={{ width: "300px" }}
              />
              <button
                type="button"
                className="btn btn-danger ml-2"
                onClick={() => handleRemoveSubfield("transitionId", index + 1)}
                style={{ width: "50px" }}
              >
                -
              </button>
            </div>
          ))}

          <button
            type="button"
            className="btn mt-2 col-md-8"
            onClick={() => handleAddSubfield("transitionId")}
            style={{ width: "300px" }}
          >
            + Add Transition Id
          </button>
        </div>


        <button type="submit" className="btn mt-3 col-md-4">
          {editId ? "Update" : "Submit"}
        </button>
      </form>

      <table className="table mt-5">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Date</th>
            <th>Alert Date</th>
            <th>Name</th>
            <th>Category</th>
            <th>Total Amount</th>
            <th>Paid</th>
            <th>Remaining</th>
            <th>Notes</th>
            <th>View Bill</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {paymentList.map((entry, index) => {
            const totalPaid = entry.paidAmount.reduce((sum, amt) => sum + parseFloat(amt || 0), 0);
            const rowClass = getAlertColor(entry.alertDate, entry.alertDays);
            return (
              <React.Fragment key={entry.id}>
              <tr className={rowClass}>
                <td>{index + 1}</td>
                <td>{entry.date[0]}</td>
                <td>{entry.alertDate || "N/A"}</td>
                <td>{entry.name}</td>
                <td>{entry.category}</td>
                <td>{entry.totalAmount}</td>
                <td>{totalPaid}</td>
                <td>{entry.remainingAmount}</td>
                <td>{entry.notes}</td>
                <td>
                  <button
                    className="btn btn-info"
                    onClick={() => toggleRow(entry.id)}
                  >
                    {expandedRows1[entry.id] ? "▲" : "▼"}
                  </button>
                </td>
                <td>
                  <button
                    className="btn btn-warning"
                    onClick={() => handleEdit(entry.id)}
                  >
                    Edit
                  </button>
                </td>
                <td>
                  <button
                    className="btn btn-danger"
                    onClick={() => handleDelete(entry.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
              {expandedRows1[entry.id] && (
                <tr>
                  <td colSpan="12">
                    <table className="table table-bordered subtable">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Date</th>
                          <th>Paid</th>
                          <th>Category</th>
                          <th>Transition ID</th>
                        </tr>
                      </thead>
                      <tbody>
                        {entry.date.map((date, subIndex) => (
                          <tr key={`${entry.id}-${subIndex}`}>
                            <td>{subIndex + 1}</td>
                            <td>{date}</td>
                            <td>{entry.paidAmount[subIndex]}</td>
                            <td>{entry.paymentCategory[subIndex]}</td>
                            <td>{entry.transitionId[subIndex]}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </td>
                </tr>
              )}
            </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PaymentDetails;
